import { useContext } from 'react';

import { apiPHP } from '../../../services/api';
import { GameContext } from '../context/GameContext';
import { iState } from '../context/interfaces';

interface PopupProps {}

export const handleFinishGame = async (
  state: iState,
  gameID: number,
  mountPopup: (properties: PopupProps) => void,
  resetScore: boolean
) => {
  const { GameTemplate, GameState } = state;
  console.log(resetScore);
  const requestBody = {
    tempo: GameState.time,
    pontuacao: resetScore ? 0 : GameState.score,
    matrix: GameTemplate.matrix,
  };

  apiPHP.post(`/passatempos/${gameID}/verificar`, requestBody).catch((err) => {
    if (resetScore) return;
    mountPopup({
      title: 'Jogo concluído!',
      message:
        'Você já pontuou neste jogo, parabéns! Se quiser apenas jogar, fique à vontade.',
      type: 'alegre',
      buttons: [
        {
          buttonText: 'ok',
          isPurple: true,
          buttonFunction: () => {},
        },
      ],
    });
  });
};
